define((require) => {
    "use strict";

    const ContentCollection   = require("data/ContentCollection");
    const RestApi             = require("shared/services/RestApi");
    const SyncManager         = require("shared/services/sync/SyncManager");

    /**
     * A collection of experiences associated to an image model
     *
     * @class ImageExperienceCollection
     * @constructor
     *
     * @param {Object} options
     * @property {id} imageId - The image id this collection is associated with (required)
     */

    const ImageExperienceCollection = ContentCollection.extend({

        /**
         * @type {String}
         */
        imageId: null,

        constructor({imageId}) {
            this.imageId = imageId;
            this.__super();
        },

        url() {
            return RestApi.pathToCollectionOnResource(RestApi.Collections.IMAGES, this.imageId, RestApi.Collections.CONTENTS);
        },

        /**
         * Counts the number of experiences associated to an image.
         *
         * @param  {ImageModel} imageModel The <tt>ImageModel</tt> instance to count the experiences for.
         *
         * @return {Promise}        A <tt>Promise</tt> that resolves with the count/number.
         */
        count() {
            const resource = RestApi.pathToCollectionOnResource(RestApi.Collections.IMAGES, this.imageId, RestApi.Collections.CONTENTS_COUNT);
            return SyncManager.get(resource, SyncManager.target("ImageExperienceCollection.count"));
        }
    });

    return ImageExperienceCollection;
});



// WEBPACK FOOTER //
// ./src/editor/ui/imageLibrary/ImageExperienceCollection.js